import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaMapMarkerAlt, FaCalendarAlt, FaUsers, FaStar, FaCheck, FaTimes, FaBus, FaClock } from 'react-icons/fa';
import BookingForm from '../../components/common/BookingForm';
import { companyInfo } from '../../data/tourData';
import './KinnerKailashTour.css';

const KinnerKailashTour = () => {
  return (
    <>
      <Helmet>
        <title>Kinner Kailash Tour - NomadTrailz</title>
        <meta name="description" content="Experience the sacred Kinner Kailash pilgrimage with NomadTrailz. Trek to the divine Kinner Kailash Shivling at 6,050 meters in Kinnaur." />
      </Helmet>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Hero Section */}
        <section className="destination-hero">
          <div className="hero-background">
            <img 
              src="https://res.cloudinary.com/duym2bgp2/image/upload/v1755008533/aolshuukh9o34joqozte.jpg" 
              alt="Kinner Kailash" 
            />
            <div className="hero-overlay"></div>
          </div>
          <div className="hero-content">
            <motion.h1 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Kinner Kailash Tour
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Sacred pilgrimage to Kinner Kailash Shivling at 6,050 meters in Kinnaur
            </motion.p>
          </div>
        </section>

        {/* Tour Details */}
        <section className="tour-details">
          <div className="container">
            <div className="details-grid">
              <div className="tour-info">
                <motion.div 
                  className="info-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <h2>Tour Overview</h2>
                  <p>
                    Kinner Kailash is one of the most sacred pilgrimage sites in the Himalayas, located in the Kinnaur district 
                    of Himachal Pradesh. This spiritual journey takes you through the pristine landscapes of Kinnaur to reach 
                    the divine Kinner Kailash Shivling at 6,050 meters. Experience the spiritual ambiance and breathtaking 
                    natural beauty with comfortable homestays and expert guidance through the challenging terrain.
                  </p>
                </motion.div>

                <motion.div 
                  className="highlights-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                >
                  <h3>Highlights</h3>
                  <ul>
                    <li>Sacred Kinner Kailash Shivling at 6,050 meters</li>
                    <li>Beautiful sunrise views from Tangling Village</li>
                    <li>Kinnaur Gate visit and cultural immersion</li>
                    <li>Ganesh Park trekking experience</li>
                    <li>Challenging high altitude trekking</li>
                    <li>Homestay experience in Tangling Village</li>
                    <li>Camping experience at Ganesh Park</li>
                    <li>Panoramic views of Kinnaur landscapes</li>
                  </ul>
                </motion.div>

                <motion.div 
                  className="itinerary-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                >
                  <h3>Itinerary</h3>
                  <div className="day-item">
                    <h4>Day 1: Pick Up | Reach | Overnight Stay</h4>
                    <ul>
                      <li>Pick up from Shimla MCD Parking by 7:00 AM</li>
                      <li>Start our Journey Shimla to Tangling Village</li>
                      <li>Halt for Breakfast in Between (not on us)</li>
                      <li>Visit Kinnaur Gate in Between Journey</li>
                      <li>Reach Tangling Village (7-8 hours)</li>
                      <li>Check-in At Home Stay. Relax for some time as you must be tired after long Journey</li>
                      <li>Dinner & over night stay</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 2: Trek to Ganesh Park | Overnight Stay</h4>
                    <ul>
                      <li>Wake up early and enjoy the beautiful sunrise</li>
                      <li>Have your Breakfast and leave for Ganesh park</li>
                      <li>Start your trek from Tangling village to Ganesh park (12 km)</li>
                      <li>Halt for Lunch in between trek</li>
                      <li>Reach Ganesh Park by 6-7 hours, check-in at camps and relax</li>
                      <li>Have evening snacks after that Briefing for next day trek</li>
                      <li>Have Dinner & Over night stay</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 3: Trek to Kinner Kailash Shivling | Overnight Stay</h4>
                    <ul>
                      <li>Wake up call at 2 AM as per briefing</li>
                      <li>Have breakfast and packed launch</li>
                      <li>Start track to kinnaur kailash shivling (6KM)</li>
                      <li>Halt for Lunch in between trek</li>
                      <li>Reach kailash by 12AM and Enjoy views of Kinner Kailash peak</li>
                      <li>After 1 hour start trek down to Ganesh Park</li>
                      <li>Have Dinner & Over night stay</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 4: Trek to Tangling Village | Reach Back to Shimla</h4>
                    <ul>
                      <li>Wake up and have breakfast & start trek down to Tangling village</li>
                      <li>Halt for Lunch in between trek</li>
                      <li>Reach home stay, fresh n up & collect your luggage then depart for Shimla</li>
                      <li>Reach shimla by 6-7 hours</li>
                    </ul>
                  </div>
                </motion.div>

                <motion.div 
                  className="inclusions-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.6 }}
                >
                  <h3>Inclusions</h3>
                  <ul>
                    <li><FaCheck className="check-icon" />Accommodation (Basic Homestay & Camps)</li>
                    <li><FaCheck className="check-icon" />Meals (3 Breakfast, 3 lunch and 3 Dinner)</li>
                    <li><FaCheck className="check-icon" />Trek Guide, Driver, Road tax, Vehicle Parking</li>
                    <li><FaCheck className="check-icon" />Transportation in Tempo traveller</li>
                    <li><FaCheck className="check-icon" />Equipment's for climbing (if required)</li>
                  </ul>
                </motion.div>

                <motion.div 
                  className="exclusions-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.8 }}
                >
                  <h3>Exclusions</h3>
                  <ul>
                    <li><FaTimes className="times-icon" />Any personal Expenses / Adventure activities</li>
                    <li><FaTimes className="times-icon" />Anything not mentioned in the itinerary</li>
                    <li><FaTimes className="times-icon" />Any kind of entry tickets/fees</li>
                    <li><FaTimes className="times-icon" />Any Meals / Drinks other than Inclusion</li>
                    <li><FaTimes className="times-icon" />5%GST</li>
                    <li><FaTimes className="times-icon" />Personal Porter</li>
                  </ul>
                </motion.div>
              </div>

              <div className="booking-section">
                <motion.div 
                  className="booking-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <h3>Book This Tour</h3>
                  <div className="price-info">
                    <span className="price">₹ 9,499</span>
                    <span className="duration">4 Days / 3 Nights</span>
                  </div>
                  
                  <div className="tour-features">
                    <div className="feature">
                      <FaMapMarkerAlt />
                      <span>Kinner Kailash, Kinnaur</span>
                    </div>
                    <div className="feature">
                      <FaCalendarAlt />
                      <span>Best Time: May to October</span>
                    </div>
                    <div className="feature">
                      <FaUsers />
                      <span>Group Size: 8-12 people</span>
                    </div>
                    <div className="feature">
                      <FaStar />
                      <span>Difficulty: Challenging</span>
                    </div>
                  </div>

                  <div className="pricing-options">
                    <h4>Cost Per Person</h4>
                    <div className="price-option">
                      <span className="option">TRIPLE SHARE</span>
                      <span className="amount">₹ 9,499 + 5% GST</span>
                    </div>
                    <div className="price-option">
                      <span className="option">DOUBLE SHARE</span>
                      <span className="amount">₹ 9,999 + 5% GST</span>
                    </div>
                  </div>
                </motion.div>

                <motion.div 
                  className="tour-logistics-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                >
                  <h3>Tour Logistics</h3>
                  <div className="logistics-grid">
                    <div className="logistics-item">
                      <FaBus className="logistics-icon" />
                      <div className="logistics-content">
                        <span className="logistics-label">Pickup Point:</span>
                        <span className="logistics-value">MCT Parking Shimla</span>
                      </div>
                    </div>
                    <div className="logistics-item">
                      <FaClock className="logistics-icon" />
                      <div className="logistics-content">
                        <span className="logistics-label">Pickup Time:</span>
                        <span className="logistics-value">7:00 AM</span>
                      </div>
                    </div>
                    <div className="logistics-item">
                      <FaMapMarkerAlt className="logistics-icon" />
                      <div className="logistics-content">
                        <span className="logistics-label">Maximum Altitude:</span>
                        <span className="logistics-value">6,050 meters</span>
                      </div>
                    </div>
                    <div className="logistics-item">
                      <FaStar className="logistics-icon" />
                      <div className="logistics-content">
                        <span className="logistics-label">Trek Distance:</span>
                        <span className="logistics-value">Approx. 25 km</span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <BookingForm 
                  tourName="Kinner Kailash Sacred Pilgrimage"
                  tourPrice="₹ 9,499"
                  tourDuration="4 Days / 3 Nights"
                />
              </motion.div>
            </div>
          </div>
        </section>
      </motion.div>
    </>
  );
};

export default KinnerKailashTour;

